import React from "react";
import { Route, Switch } from "react-router-dom";
import { RegionsDirectory } from "../RegionsDirectory";
import { RegionShowPage } from "../RegionShowPage";

export const routes = (
  <Switch>
    <Route path="/regions" exact component={RegionsDirectory} />
    <Route path="/regions/:zone/:countryCode/:slug" component={RegionShowPage} />
    <Route path="/regions/:zone/:countryCode" component={RegionsDirectory} />
  </Switch>
);
